import React from 'react';
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import ViewProfiles from './pages/ViewProfiles';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Faq from './pages/Faq';
import TermsAndConditions from './pages/TermsAndConditions';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ViewTeams from './pages/ViewTeams';
import Settings from './pages/Settings';
import SignOut from './pages/SignOut';
import Messages from './pages/Messages';
import ViewTeamProfile from './pages/ViewTeamProfile';
import CreateTeam from './pages/CreateTeam';
import './App.css';
import EditTeam from './pages/EditTeam';
import ViewMessages from './pages/ViewMessages';
import NotFoundPage from './pages/NotFound';

function App() {
  const igp = window.location.origin;
  const isGitHubPages = (igp === 'https://osalotioman.github.io');

  const Router = isGitHubPages ? HashRouter : BrowserRouter;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/view_profiles" element={<ViewProfiles />} />
        <Route path="/view_teams" element={<ViewTeams />} />
        <Route path="/sign_in" element={<SignIn />} />
        <Route path="/sign_up" element={<SignUp />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
        <Route path="/profile/:username" element={<Profile />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/reset_password" element={<ResetPassword />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/sign_out" element={<SignOut />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/team/:teamname" element={<ViewTeamProfile />} />
        <Route path="/create_team" element={<CreateTeam />} />
        <Route path="/edit_team/:teamname" element={<EditTeam />} />
        <Route path="/messages/:username" element={<ViewMessages />} />

        <Route path="/ncpc/" element={<Home />} />
        <Route path="/ncpc/view_profiles" element={<ViewProfiles />} />
        <Route path="/ncpc/sign_in" element={<SignIn />} />
        <Route path="/ncpc/sign_up" element={<SignUp />} />
        <Route path="/ncpc/faq" element={<Faq />} />
        <Route path="/ncpc/terms_and_conditions" element={<TermsAndConditions />} />
        <Route path="/ncpc/profile/:username" element={<Profile />} />
        <Route path="/ncpc/profile" element={<Profile />} />
        <Route path="/ncpc/forgot_password" element={<ForgotPassword />} />
        <Route path="/ncpc/reset_password" element={<ResetPassword />} />
        <Route path="/ncpc/settings" element={<Settings />} />
        <Route path="/ncpc/sign_out" element={<SignOut />} />
        <Route path="/ncpc/messages" element={<Messages />} />
        <Route path="/ncpc/team/:teamname" element={<ViewTeamProfile />} />
        <Route path="/ncpc/create_team" element={<CreateTeam />} />
        <Route path="/ncpc/edit_team/:teamname" element={<EditTeam />} />
        <Route path="/ncpc/messages/:username" element={<ViewMessages />} />

        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
